import { OrganizationService } from 'src/app/common/services/organization/organization.service';
import { Subscription } from 'rxjs';
import { Component, OnInit } from '@angular/core';
import { FormlyFormOptions, FormlyFieldConfig } from '@ngx-formly/core/public_api';
import { FormGroup } from '@angular/forms';
import {
  DialogService,
  DynamicDialogConfig,
  DynamicDialogRef
} from 'primeng/dynamicdialog';
import { IOrganization } from 'src/app/common/model/organization.model';

@Component({
  selector: 'app-receipts-customize',
  templateUrl: './receipts-customize.component.html',
  styleUrls: ['./receipts-customize.component.scss'],
  providers: [DialogService]
})
export class ReceiptsCustomizeComponent implements OnInit {
  subscription = new Subscription();
  currentOrganization!: IOrganization;

  displayGuide = false;

  customizeDocumentForm = new FormGroup({});
  model: any = {};
  options: FormlyFormOptions = {};
  fields: FormlyFieldConfig[] = [
    {
      key: 'tagline',
      type: 'input',
      props: {
        label: 'Tagline',
        placeholder: 'Enter your organization tagline for the invoice footer'
      }
    },
    {
      key: 'privacyPolicy',
      type: 'editor',
      props: {
        label: 'Privacy Policy'
      }
    }
  ];
  constructor(
    private organizationService: OrganizationService,
    public dialogService: DialogService,
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig
  ) {}

  ngOnInit(): void {
    this.getCurrentOrganization();
  }

  getCurrentOrganization(): void {
    this.subscription.add(
      this.organizationService.getCurrentOrganization().subscribe((res) => {
        this.currentOrganization = res.result.organization;
        this.model = this.config.data;
      })
    );
  }

  customizeOrUpdateDocument(form: any): void {
    this.ref.close(form.value);
  }

  showPositionDialog() {
    this.displayGuide = true;
  }
}
